import { Price } from '../shared/types/Price';
import { isPriceOnRequest } from './price';

export const areTaxesExcluded = (isDealer?: boolean, price?: Price) => {
  const isOnRequest = isPriceOnRequest(isDealer, price);
  return isDealer && !isOnRequest && !!price?.isNet;
};
